// Quantity offers retain real Shopify variants and native automatic discount accounting.
for (const widget of document.querySelectorAll('[data-nc-offers]')) {
  if (widget.dataset.ncReady) continue;
  const root = widget.closest('[data-nc-product]');
  const component = widget.closest('product-form-component');
  const form = widget.closest('form');
  const variants = JSON.parse(document.querySelector(`[data-nc-variants="${root.dataset.ncProduct}"]`).textContent);
  const money = cents => new Intl.NumberFormat('fr-FR', {style:'currency',currency:widget.dataset.ncCurrency}).format(cents / 100);
  const unitFormatter = new Intl.NumberFormat('fr-FR', {style:'currency',currency:widget.dataset.ncCurrency});
  function setUnitPrice(label, cents) {
    const parts = unitFormatter.formatToParts(cents / 100);
    const amount = parts.filter(part => part.type !== 'currency').map(part => part.value).join('').trim();
    const currency = document.createElement('span');
    currency.className = 'nc-offer__currency';
    currency.textContent = parts.find(part => part.type === 'currency')?.value || widget.dataset.ncCurrency;
    label.replaceChildren(document.createTextNode(amount + '\u00a0'), currency);
  }
  const roundedMoney = cents => new Intl.NumberFormat('fr-FR', {style:'currency',currency:widget.dataset.ncCurrency,minimumFractionDigits:0,maximumFractionDigits:0}).format(cents / 100);
  // Delivery contributes once per qualifying pack, using the same market rates as the cart.
  const shippingPaid = Number(widget.dataset.ncShippingPaid) || 0;
  const shippingFreeFrom = Number(widget.dataset.ncShippingFreeFrom) || 0;
  const shippingSaving = total => shippingFreeFrom > 0 && total >= shippingFreeFrom ? shippingPaid : 0;
  const savingDetail = (discount, shipping) => shipping > 0
    ? `${money(discount)} sur les ensembles + ${money(shipping)} de livraison standard offerte = ${money(discount + shipping)} d’économies au total.`
    : `${money(discount)} d’économies sur les ensembles ; livraison en supplément selon la destination.`;
  // Native fixed order rebate: 12 EUR. Shopify supplies the presentment conversion rate.
  const exchangeRate = widget.dataset.ncCurrency === 'EUR' ? 1 : Number(window.Shopify?.currency?.rate);
  const hasDuoRate = Number.isFinite(exchangeRate) && exchangeRate > 0;
  const fixedDuoSaving = hasDuoRate ? Math.round(1200 * exchangeRate) : 0;
  if (!hasDuoRate) widget.querySelector('.nc-offer--recommended').hidden = true;
  const duoTotal = cents => cents * 2 - fixedDuoSaving;
  const byId = id => variants.find(variant => String(variant.id) === String(id));
  const extraSelects = [...widget.querySelectorAll('[data-nc-pack-variant]')];
  const inventory = new Map(JSON.parse(root.querySelector('[data-nc-stock-data]')?.textContent || '[]').map(v => [String(v.id), v]));
  function refresh() {
    const count = Number(widget.querySelector('[name="nc-pack"]:checked')?.value || 1);
    const first = byId(form.querySelector('[data-nc-variant-id]').value);
    if (!first) return;
    widget.dataset.ncPackCount = String(count);
    const selected = [first];
    extraSelects.forEach(select => {
      const active = Number(select.dataset.ncPackVariant) <= count;
      select.closest('[data-nc-pack-row]').hidden = !active;
      select.disabled = !active;
      if (active) selected.push(byId(select.value));
    });
    widget.querySelector('[data-nc-pack-mix]').hidden = count === 1;
    widget.querySelector('[data-nc-first-variant]').textContent = first.title;
    let available = selected.length === count && selected.every(variant => variant?.available);
    const subtotal = selected.reduce((total, variant) => total + (variant?.price || 0), 0);
    const gift = count === 4 ? Math.min(...selected.map(variant => variant?.price || 0)) : 0;
    const duoDiscount = count === 2 ? fixedDuoSaving : 0;
    const total = subtotal - gift - duoDiscount;
    const grouped = new Map();
    selected.filter(Boolean).forEach(variant => grouped.set(String(variant.id), (grouped.get(String(variant.id)) || 0) + 1));
    available = available && [...grouped].every(([id, quantity]) => {
      const stock = inventory.get(id);
      return !stock?.tracked || stock.quantity >= quantity;
    });
    if (!available) grouped.clear();
    widget.querySelector('[data-nc-pack-items]').value = JSON.stringify([...grouped].map(([variantId,quantity]) => ({variantId,quantity})));
    widget.querySelectorAll('[data-nc-offer-price]').forEach(label => {
      const quantity = Number(label.dataset.ncOfferPrice);
      label.textContent = money(quantity === 2 ? duoTotal(first.price) : first.price * (quantity === 4 ? 3 : quantity));
    });
    widget.querySelectorAll('[data-nc-offer-unit]').forEach(label => {
      const quantity = Number(label.dataset.ncOfferUnit);
      setUnitPrice(label, quantity === 2 ? duoTotal(first.price) / 2 : first.price * (quantity === 4 ? 3 / 4 : 1));
    });
    const duoShipping = shippingSaving(duoTotal(first.price));
    const tribuShipping = shippingSaving(first.price * 3);
    widget.querySelector('[data-nc-duo-saving-rounded]').textContent = roundedMoney(fixedDuoSaving + duoShipping);
    widget.querySelector('[data-nc-tribu-saving-rounded]').textContent = roundedMoney(first.price + tribuShipping);
    widget.querySelector('[data-nc-duo-saving-detail]').textContent = savingDetail(fixedDuoSaving, duoShipping);
    widget.querySelector('[data-nc-tribu-saving-detail]').textContent = savingDetail(first.price, tribuShipping);
    const summary = root.querySelector('[data-nc-pack-summary]');
    summary.hidden = count === 1;
    summary.textContent = count === 4 ? 'Pack Tribu · 4 ensembles, dont 1 offert' : 'Pack Duo · 2 ensembles';
    const saving = widget.querySelector('[data-nc-pack-saving]');
    const selectedShipping = count > 1 ? shippingSaving(total) : 0;
    saving.textContent = count > 1 ? `${money(gift + duoDiscount + selectedShipping)} économisés${selectedShipping > 0 ? ', livraison standard incluse' : ''} · ${money(total / count)} par ensemble.` : '';
    root.querySelector('[data-nc-submit-text]').textContent = available ? `Ajouter au panier - ${money(total)}` : 'Sélection indisponible';
    root.querySelector('[data-nc-submit]').disabled = !available || component.hasAttribute('data-nc-pack-pending');
    const delivery = root.querySelector('[data-nc-delivery-free-from]');
    if (delivery && Number(delivery.dataset.ncDeliveryFreeFrom) > 0) {
      const standard = delivery.querySelector('[data-nc-delivery-standard]');
      if (standard) standard.textContent = total >= Number(delivery.dataset.ncDeliveryFreeFrom) ? 'offerte' : delivery.dataset.ncDeliveryPaid;
    }
  }
  widget.addEventListener('change', refresh);
  root.querySelectorAll('[data-nc-option] input').forEach(input => input.addEventListener('change', refresh));
  component.addEventListener('nocroute:pack-add-end', refresh);
  root.addEventListener('nocroute:inventory', event => {
    for (const stock of event.detail.variants) {
      inventory.set(String(stock.id), stock);
      const variant = byId(stock.id);
      if (variant) variant.available = stock.available;
      for (const select of extraSelects) {
        const option = [...select.options].find(item => item.value === String(stock.id));
        if (option) { option.disabled = !stock.available; option.textContent = stock.title + (stock.available ? '' : ' — indisponible'); }
      }
    }
    refresh();
  });
  widget.dataset.ncReady = 'true';
  refresh();
  widget.hidden = false;
}
